/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The recording mode of the bot.

Determines what the bot records during the meeting:

- `speaker_view`: Records the speaker's view (default). Shows the active speaker or presenter.
- `audio_only`: Records only the audio without video.
- `gallery_view`: Records the entire gallery view (coming soon).

Default: `speaker_view`
 */
export type CreateCalendarBotRequestBodyInputAllOfRecordingMode =
  (typeof CreateCalendarBotRequestBodyInputAllOfRecordingMode)[keyof typeof CreateCalendarBotRequestBodyInputAllOfRecordingMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCalendarBotRequestBodyInputAllOfRecordingMode = {
  audio_only: "audio_only",
  speaker_view: "speaker_view",
  gallery_view: "gallery_view"
} as const
